function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
  })

  if (summary.closest('header-drawer, menu-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true
  )
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)))
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange(event) {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle('disabled', value <= min)
      if (this.input.min === 0 && this.input.value === 0) {
        const currentItem = document.querySelector(`#CartDrawer-Item-${this.input.dataset.index}`)
        currentItem.querySelector('.cart-remove-button').click()
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const parentMenuElement = detailsElement.closest('.has-submenu')
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus)
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        parentMenuElement && parentMenuElement.classList.add('submenu-open')
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus)
      }, 100)
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return

    this.mainDetailsToggle.classList.remove('menu-opening')
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open')
    })
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false)
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open')
    parentMenuElement && parentMenuElement.classList.remove('submenu-open')
    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false)
    removeTrapFocus(detailsElement.querySelector('summary'))
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'))
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header')
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header')
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.stickyHeader.getBoundingClientRect().bottom - this.borderOffset)}px`
    )
    this.header.classList.add('menu-open')

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    window.addEventListener('resize', this.onResize)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return
    super.closeMenuDrawer(event, elementToFocus)
    this.header.classList.remove('menu-open')
    window.removeEventListener('resize', this.onResize)
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.stickyHeader.getBoundingClientRect().bottom - this.borderOffset)}px`
      )
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false))
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    document.body.dispatchEvent(new CustomEvent('modalClosed'))
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')

    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent(focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'))
      if (focus) deferredElement.focus()
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play()
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('[id^="Slider-"]')
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.sliderItemsToShow = []
    this.enableSliderLooping = true
    this.currentPageElement = this.querySelector('.slider-counter--current')
    this.pageTotalElement = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')

    if (!this.slider || !this.nextButton) return

    this.initPages()
    const resizeObserver = new ResizeObserver((entries) => this.initPages())
    resizeObserver.observe(this.slider)

    this.slider.addEventListener('scroll', this.update.bind(this))
    this.prevButton?.addEventListener('click', this.onButtonClick.bind(this))
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
  }

  initPages() {
    if (this.sliderItemsToShow.length === 0) {
      this._computePages()
    }

    if (this._initPagesRaf) cancelAnimationFrame(this._initPagesRaf)
    this._initPagesRaf = requestAnimationFrame(() => {
      this._initPagesRaf = null
      this._computePages()
    })
  }

  _computePages() {
    const items = this.sliderItems
    const visible = []
    for (let i = 0, len = items.length; i < len; i++) {
      if (items[i].offsetParent !== null) visible.push(items[i])
    }
    if (visible.length < 2) {
      this.sliderItemsToShow = visible
      this.sliderItemOffset = 0
      this.slidesPerPage = visible.length === 0 ? 1 : visible.length
      this.totalPages = visible.length === 0 ? 0 : 1
      this.currentPage = visible.length === 0 ? 0 : 1
      this.update()
      return
    }

    // Batch all layout reads
    const offset0 = visible[0].offsetLeft
    const offset1 = visible[1].offsetLeft
    const sliderWidth = this.slider.clientWidth

    // Compute derived values
    const itemOffset = offset1 - offset0
    const slidesPerPage = Math.floor((sliderWidth - offset0) / itemOffset)
    const totalPages = visible.length - slidesPerPage + 1

    const sameGeometry =
      this.sliderItemsToShow.length === visible.length &&
      this.sliderItemOffset === itemOffset &&
      this.slidesPerPage === slidesPerPage &&
      this.totalPages === totalPages
    const sameVisibleOrder =
      visible.length === this.sliderItemsToShow.length &&
      visible.every((el, i) => el === this.sliderItemsToShow[i])

    if (sameGeometry && sameVisibleOrder) {
      return
    }

    this.sliderItemsToShow = visible
    this.sliderItemOffset = itemOffset
    this.slidesPerPage = slidesPerPage
    this.totalPages = totalPages
    this.update()
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.initPages()
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return

    if (!this.sliderItemOffset) {
      if (this.pageTotalElement && this.totalPages !== undefined) {
        this.pageTotalElement.textContent = String(this.totalPages)
      }
      if (this.currentPageElement && this.currentPage) {
        this.currentPageElement.textContent = String(this.currentPage)
      }
      return
    }

    const previousPage = this.currentPage
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1

    if (this.currentPageElement) {
      this.currentPageElement.textContent = this.currentPage
    }

    if (this.pageTotalElement && this.totalPages !== undefined) {
      this.pageTotalElement.textContent = String(this.totalPages)
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      )
    }

    if (this.enableSliderLooping) return

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton?.setAttribute('disabled', 'disabled')
    } else {
      this.prevButton?.removeAttribute('disabled')
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled')
    } else {
      this.nextButton.removeAttribute('disabled')
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
  }

  isVerticalSlideVisible(element, offset = 0) {
    // scroll thumbnail to middle

    const top = element.offsetTop - this.slider.clientHeight / 2
    this.slider.scrollTo({
      top,
      behavior: 'smooth',
    })
    // const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
    // return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
  }

  onButtonClick(event) {
    event.preventDefault()
    if (!this.sliderItemOffset) return
    const step = event.currentTarget.dataset.step || 1
    let pageSwipe = this.slidesPerPage
    if (pageSwipe === 0) {
      pageSwipe = 1
    }

    if (pageSwipe >= 2 && window.innerWidth > 1024) pageSwipe = pageSwipe + 1
    else if (window.innerWidth > 750 && window.innerWidth <= 1024 && pageSwipe >= 2) pageSwipe = pageSwipe - 1

    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset * pageSwipe
        : this.slider.scrollLeft - step * this.sliderItemOffset * pageSwipe

    const isLastSlide =
      this.slideScrollPosition + this.sliderItemOffset / 4 >= this.sliderItemsToShow.length * this.sliderItemOffset
    if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0
    }

    const isFirstSlide = this.currentPage === 1
    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * this.sliderItemsToShow.length
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    })
  }
}

customElements.define('slider-component', SliderComponent)

class SlideshowComponent extends SliderComponent {
  constructor() {
    super()
    this.sliderControlWrapper = this.querySelector('.slider-buttons')
    this.enableSliderLooping = true

    if (!this.sliderControlWrapper) return

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'))
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)))
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this))
    this.setSlideVisibility()

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.reducedMotion.addEventListener('change', () => {
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay()
    })

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay()
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000
    this.addEventListener('mouseover', this.focusInHandling.bind(this))
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this))
    this.addEventListener('focusin', this.focusInHandling.bind(this))
    this.addEventListener('focusout', this.focusOutHandling.bind(this))

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this))
      this.autoplayButtonIsSetToPlay = true
      this.play()
    } else {
      this.reducedMotion.matches ? this.pause() : this.play()
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event)
    const isFirstSlide = this.currentPage === 1
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length

    if (!isFirstSlide && !isLastSlide) return

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * this.sliderItemsToShow.length
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    })
  }

  update() {
    super.update()
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')
    this.prevButton?.removeAttribute('disabled')

    if (!this.sliderControlButtons.length) return
    if (this.currentPage < 1 || this.currentPage > this.sliderControlButtons.length) return

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active')
      link.removeAttribute('aria-current')
    })
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active')
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true)
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay)
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play()
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target)
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return
      this.play()
    } else if (!this.reducedMotion.matches) {
      this.play()
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target)
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play()
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause()
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause()
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off')
    clearInterval(this.autoplay)
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite')
    clearInterval(this.autoplay)
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused')
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow)
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused')
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow)
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const focusableElements = item.querySelectorAll('a, input, button')
      if (index === this.currentPage - 1) {
        if (focusableElements.length)
          focusableElements.forEach((el) => {
            el.removeAttribute('tabindex')
          })
        item.setAttribute('aria-hidden', 'false')
        item.setAttribute('tabindex', '0')
      } else {
        if (focusableElements.length)
          focusableElements.forEach((el) => {
            el.setAttribute('tabindex', '-1')
          })
        item.setAttribute('aria-hidden', 'true')
        item.setAttribute('tabindex', '-1')
      }
    })
  }

  linkToSlide(event) {
    event.preventDefault()
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage)
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }
}

customElements.define('slideshow-component', SlideshowComponent)

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

/**
 * PDP volume/weight row: one `.js-current-option-info` per variant under `#VolumeWeight-{sectionId}`.
 * Keeps imperial/metric/weight markup in sync with the selected variant.
 */
function syncVolumeWeightForVariant(variantId) {
  if (variantId == null) return
  const id = variantId.toString()
  document.querySelectorAll('[id^="VolumeWeight-"] .js-current-option-info').forEach((el) => {
    el.classList.toggle('hidden', el.dataset.variantId !== id)
  })
}

class VariantRadios extends HTMLElement {
  constructor() {
    super()

    this.section = this.closest('.shopify-section') || this.closest('cart-drawer')
    this.productSplides = Array.from(this.section?.querySelectorAll('product-splide') || [])

    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.removeErrorMessage()
    this.updateVariantStatuses()
    this.updateATCButton()
    this.updateStickyATCButton()
    this.updateStickyVariantInfoAndMedia()

    if (this.currentVariant) {
      this.updateURL()
      this.updateVariantInput()
      this.updateProductMedia()
      this.updateVariantInfo()
      this.renderFeaturedReviews()
      this.updateShareUrl()
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    })
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateURL() {
    if (
      !this.currentVariant ||
      this.dataset.updateUrl === 'false' ||
      (typeof this.dataset.url === 'string' && !window.location.pathname.includes(this.dataset.url))
    )
      return

    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-product-form-${this.dataset.section}`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
      document.dispatchEvent(
        new CustomEvent('variantChanged', {
          detail: { variantId: this.currentVariant.id },
        })
      )
    })
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    )
    const inputWrappers = [...this.querySelectorAll('.product-form__input')]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`])
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    // if (productForm) productForm.handleErrorMessage();
  }

  renderFeaturedReviews() {
    if (!this.closest('body.product-template')) return

    const reviewsDestination = document.getElementById('FeaturedReviews')

    if (!reviewsDestination) return

    const requestedVariantId = this.currentVariant.id

    fetch(`${window.location.href}&section_id=featured-reviews`)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const source = html.getElementById('FeaturedReviews')

        if (source) {
          reviewsDestination.innerHTML = source.innerHTML
        }
      })
  }

  updateVariantInfo() {
    const variantId = this.currentVariant.id.toString()
    const toggle = (variantInfo) => {
      variantInfo.classList.toggle('hidden', variantInfo.dataset.variantId !== variantId)
    }
    this.querySelectorAll('.js-current-option-info').forEach(toggle)
    syncVolumeWeightForVariant(this.currentVariant.id)
  }

  updateProductMedia() {
    if (this.productSplides.length === 0 || !this.currentVariant) return

    // Don't update product media if inside product-card
    const parentProductCard = this.closest('.product-card')
    if (parentProductCard) return

    // Check if this is a bundle page and if we're in recommendation mode
    const hasBundleProducts = document.querySelector('.product-bundle-variant-picker')
    const isRecommendationMode = document.body.dataset.applyingRecommendations === 'true'

    this.productSplides.forEach((productSplide) => {
      // On bundle pages during recommendation mode, only show and update the main product gallery
      // After recommendation mode, allow normal gallery switching
      if (hasBundleProducts && isRecommendationMode) {
        const isMainGallery = productSplide === this.productSplides[0]
        if (isMainGallery) {
          productSplide.classList.remove('!hidden')
          // Only filter slides if this variant belongs to the main product
          if (
            productSplide.dataset.variantIds.includes(this.currentVariant.id.toString()) ||
            productSplide.dataset.originalVariantIds?.includes(this.currentVariant.id.toString())
          ) {
            productSplide.filterSlides(this.currentVariant)
          }
        }
        // Keep all other galleries (bundle products) hidden during recommendation mode
      } else {
        // Normal behavior for non-bundle pages or after recommendation mode
        if (
          productSplide.dataset.variantIds.includes(this.currentVariant.id.toString()) ||
          productSplide.dataset.originalVariantIds?.includes(this.currentVariant.id.toString())
        ) {
          productSplide.classList.remove('!hidden')
          productSplide.filterSlides(this.currentVariant)
        } else {
          productSplide.classList.add('!hidden')
        }
      }
    })
  }

  updateSiteWideSalePrices($siteWideSaleTierOne, $siteWideSaleTierTwo, $fullPrice, $salePrice) {
    const $priceWrapper = $fullPrice.closest('[id^="price-"]')
    const excludedVariantIds = $priceWrapper.dataset.excludedVariantIds
    const currentVariantIsExcluded = excludedVariantIds.includes(this.currentVariant.id.toString())

    if (currentVariantIsExcluded) {
      $siteWideSaleTierOne.style.display = 'none'
      $siteWideSaleTierTwo.style.display = 'none'

      $fullPrice.textContent = formatter.format(
        (this.currentVariant.compare_at_price || this.currentVariant.price) / 100
      )

      if (this.currentVariant.compare_at_price > this.currentVariant.price) {
        $fullPrice.classList.add('line-through')
        $salePrice.textContent = formatter.format(this.currentVariant.price / 100)
        $salePrice.style.display = 'inline-block'
      } else {
        $fullPrice.classList.remove('line-through')
        $salePrice.style.display = 'none'
      }
    } else {
      $fullPrice.textContent = formatter.format(
        (this.currentVariant.compare_at_price || this.currentVariant.price) / 100
      )
      $fullPrice.classList.add('line-through')
      $salePrice.style.display = 'none'

      const siteWideSaleTierOneSelected = $siteWideSaleTierOne.hasAttribute('selected')
      if (siteWideSaleTierOneSelected) {
        $siteWideSaleTierOne.textContent = formatter.format(
          (this.currentVariant.price * parseFloat($siteWideSaleTierOne.dataset.discount)) / 100
        )
        $siteWideSaleTierOne.style.display = 'inline-block'

        $siteWideSaleTierTwo.style.display = 'none'
      } else {
        $siteWideSaleTierTwo.textContent = formatter.format(
          (this.currentVariant.price * parseFloat($siteWideSaleTierTwo.dataset.discount)) / 100
        )
        $siteWideSaleTierTwo.style.display = 'inline-block'
        $siteWideSaleTierOne.style.display = 'none'
      }
    }
  }

  updatePrices($fullPrice, $salePrice) {
    if (this.currentVariant.compare_at_price) {
      $fullPrice.textContent = formatter.format(this.currentVariant.compare_at_price / 100)
      $fullPrice.classList.add('line-through')
      $salePrice.textContent = formatter.format(this.currentVariant.price / 100)
      $salePrice.style.display = 'inline-block'
    } else {
      $fullPrice.textContent = formatter.format(this.currentVariant.price / 100)
      $fullPrice.classList.remove('line-through')
      $salePrice.style.display = 'none'
    }
  }

  updateATCButton() {
    // Product form id used for product cards, section id used for main product section
    const $atcButton =
      document.getElementById(`ProductSubmitButton-${this.dataset.productFormId}`) ||
      document.getElementById(`ProductSubmitButton-${this.dataset.section}`)
    if (!$atcButton) return console.warn('No ATC button found')

    const $atcButtonText = $atcButton.querySelector('span')
    if (!$atcButtonText) return console.error('No ATC button text found')

    $atcButton.toggleAttribute('disabled', !this.currentVariant.available)

    const $productCard = this.closest('.js-product-card, .js-bundle-product-card, .js-upsell-product-card')
    // Skio plan picker will update the price if it exists
    const $skioPlanPicker = this.section?.querySelector('skio-plan-picker')
    if ($skioPlanPicker) return

    if ($productCard) {
      const $fullPrice = $atcButton.querySelector('[data-full-price]')
      const $salePrice = $atcButton.querySelector('[data-sale-price]')
      if (!$fullPrice) return console.error('No full price element found')
      if (!$salePrice) return console.error('No sale price element found')

      const $siteWideSaleTierOne = $atcButton.querySelector('[data-site-wide-sale-tier-one]')
      const $siteWideSaleTierTwo = $atcButton.querySelector('[data-site-wide-sale-tier-two]')

      const sitewideSaleIsActive = $siteWideSaleTierOne?.dataset?.discount || $siteWideSaleTierTwo?.dataset?.discount

      if (sitewideSaleIsActive) {
        this.updateSiteWideSalePrices($siteWideSaleTierOne, $siteWideSaleTierTwo, $fullPrice, $salePrice)
      } else {
        this.updatePrices($fullPrice, $salePrice)
      }

      const customButtonText = $atcButton.dataset.variantText
        ? $atcButton.dataset.variantText
        : $atcButtonText.dataset.variantText
      const customVariant = $atcButton.dataset.variantId
        ? $atcButton.dataset.variantId
        : $atcButtonText.dataset.variantId
      const $priceWrapper = $fullPrice.closest('[id^="price-"]')

      if (customButtonText && this.currentVariant.id.toString() === customVariant) {
        $atcButtonText.textContent = customButtonText
        if ($priceWrapper) $priceWrapper.style.display = 'none'
      } else {
        if ($priceWrapper) $priceWrapper.style.display = ''
        $atcButtonText.textContent = this.currentVariant.available
          ? 'Add' + ' —\u00A0'
          : window.variantStrings.soldOut + ' —\u00A0'
      }
    } else {
      const $productInfo = this.section?.querySelector('product-info')
      if (!$productInfo) return

      const $fullPrice = $productInfo.querySelector('[data-full-price]')
      const $salePrice = $productInfo.querySelector('[data-sale-price]')
      const $siteWideSaleTierOne = $productInfo.querySelector('[data-site-wide-sale-tier-one]')
      const $siteWideSaleTierTwo = $productInfo.querySelector('[data-site-wide-sale-tier-two]')

      const sitewideSaleIsActive = $siteWideSaleTierOne?.dataset?.discount || $siteWideSaleTierTwo?.dataset?.discount

      if (sitewideSaleIsActive) {
        this.updateSiteWideSalePrices($siteWideSaleTierOne, $siteWideSaleTierTwo, $fullPrice, $salePrice)
      } else {
        this.updatePrices($fullPrice, $salePrice)
      }
    }
  }

  updateStickyATCButton() {
    const $stickyAddToCart = document.querySelector('sticky-add-to-cart')
    if (!$stickyAddToCart) return

    const $atcButton = $stickyAddToCart.querySelector('[name="add"]')
    if (!$atcButton) return

    const $atcButtonText = $atcButton.querySelector('span')
    $atcButtonText.textContent = this.currentVariant.available
      ? window.variantStrings.addToCart + ' —\u00A0'
      : window.variantStrings.soldOut + ' —\u00A0'

    $atcButton.toggleAttribute('disabled', !this.currentVariant.available)

    // Skio plan picker will update the price if it exists
    const $skioPlanPicker = this.section?.querySelector('skio-plan-picker')
    if ($skioPlanPicker) return

    const $fullPrice = $atcButton.querySelector('[data-full-price]')
    const $salePrice = $atcButton.querySelector('[data-sale-price]')
    const $siteWideSaleTierOne = $atcButton.querySelector('[data-site-wide-sale-tier-one]')
    const $siteWideSaleTierTwo = $atcButton.querySelector('[data-site-wide-sale-tier-two]')

    const sitewideSaleIsActive = $siteWideSaleTierOne?.dataset?.discount || $siteWideSaleTierTwo?.dataset?.discount

    if (sitewideSaleIsActive) {
      this.updateSiteWideSalePrices($siteWideSaleTierOne, $siteWideSaleTierTwo, $fullPrice, $salePrice)
    } else {
      this.updatePrices($fullPrice, $salePrice)
    }
  }

  updateStickyVariantInfoAndMedia() {
    const stickyAddToCart = document.querySelector('sticky-add-to-cart')
    if (!stickyAddToCart) return

    const variantTitle = stickyAddToCart.querySelector('.js-sticky-variant-title')
    if (!variantTitle) return

    variantTitle.textContent = this.currentVariant.title

    const featuredImages = stickyAddToCart.querySelectorAll('.js-sticky-featured-images-container img')
    featuredImages.forEach((image) => {
      image.classList.toggle('hidden', image.dataset.variantId !== this.currentVariant.id.toString())
    })
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-radios', VariantRadios)

document.addEventListener('variantChanged', (e) => {
  const variantId = e.detail?.variantId
  if (variantId == null) return
  syncVolumeWeightForVariant(variantId)
})

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
        } else {
          // If no recommendations are loaded, potentially remove the element
          // or hide it, depending on desired behavior.
          // This preserves the logic of the original .remove() call
          // if the recommendations loaded but were empty or didn't contain a slideshow.
          // We check if it's the complementary-products section *before* potentially removing it.
          if (this.classList.contains('complementary-products')) {
            // Original logic checked for slideshow *after* potentially adding content.
            // We replicate the idea: if fetched content doesn't add a slideshow, remove.
            // A simple check is if the fetched 'recommendations' element exists and has content,
            // and *that* content includes a slideshow.
            if (
              !(
                recommendations &&
                recommendations.innerHTML.trim().length &&
                recommendations.querySelector('slideshow-component')
              )
            ) {
              this.remove()
            }
          }
        }

        // Add loaded class if content was successfully injected
        if (this.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded')
        }
      })
      .catch((e) => {
        console.error('Failed to load product recommendations:', e)
        // Optionally remove the element on fetch failure too
        if (this.classList.contains('complementary-products')) {
          this.remove()
        }
      })
  }
}

customElements.define('product-recommendations', ProductRecommendations)

// Handle mega menu navigation
document.addEventListener('DOMContentLoaded', function () {
  // Add click handlers for mega menu summary elements
  document.querySelectorAll('summary[data-link-url]').forEach((summary) => {
    summary.addEventListener('click', function (event) {
      const url = this.getAttribute('data-link-url')
      if (url) {
        // Check if this is a keyboard event (Enter or Space)
        if (event.type === 'keydown') {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            window.location.href = url
          }
        } else {
          // For mouse clicks, navigate immediately
          window.location.href = url
        }
      }
    })

    // Add keyboard support
    summary.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        const url = this.getAttribute('data-link-url')
        if (url) {
          window.location.href = url
        }
      }
    })
  })
})
